import React from "react";

import { makeStyles } from '@material-ui/core'
import { Tooltip, Fab, FabProps } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    fab: {
        position: 'absolute',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    fab2: {
        bottom: 0,
        margin: theme.spacing(4),
        position: 'fixed',
        right: 20,
        zIndex: theme.zIndex.speedDial,
        bgcolor: 'transparent',
        boxShadow: 'none',
        ':hover': {
            bgcolor: 'transparent',
            boxShadow: 'none'
        },
    }
}))

export interface CustomFabProps extends FabProps {
    toolTipTitle?: string
}

export default function CustomFab(props: CustomFabProps) {
    const classes = useStyles(props);

    var {
        color,
        toolTipTitle,
        ...rest
    } = props;



    return (
        <Tooltip title={toolTipTitle ?? ""} arrow hidden={toolTipTitle == null}>
            <Fab color={color ?? "primary"} className={classes.fab2} {...rest}>

            </Fab>
        </Tooltip>
    )
}